import { useContext } from "react";

import { TrailingOverrideContext } from "../../context/sectionTabs/TrailingOverrideContext";
import type { TrailingOverrideContextValue } from "../../context/sectionTabs/types";

const noop = () => {};

/**
 * No-op fallback when consumed outside a MobileSectionTabsProvider.
 */
const FALLBACK_CONTEXT: TrailingOverrideContextValue = {
  trailingOverride: null,
  setTrailingOverride: noop,
};

/**
 * Register/read the mobile shell's default-TopBar trailing-slot override.
 */
export const useMobileTrailingOverride = () => {
  const context = useContext(TrailingOverrideContext);
  if (!context && process.env.NODE_ENV === "development") {
    console.warn(
      "useMobileTrailingOverride: called outside MobileSectionTabsProvider, using noop fallback. " +
        "This is expected for pages on the legacy app shell path.",
    );
  }
  return context ?? FALLBACK_CONTEXT;
};
